import { Component, OnInit, Input, SimpleChanges, OnChanges, DoCheck, Output } from '@angular/core';
import { FFService } from '../../../ff/ff.service';
import { EventEmitter } from '@angular/core';

// A component that can take on 0-N datasets or 0-N json objects
// It will keep state and filter/search based on some conditions
// We need this component to have a data attribute attribute
// where the user can pass the data/datasets


@Component({
  selector: 'ff-search-and-filter',
  templateUrl: './search-and-filter.component.html',
  styleUrls: ['./search-and-filter.component.scss'],
})
export class SearchAndFilterComponent implements OnInit {

  ff;
  @Input() data: any;
  @Output() new_data = new EventEmitter();
  raw_data;
  operating_data = [];
  data_statistics = {} as any;
  ignored_keys = ['_id', 'uri_template', 'namespace', 'uuid'];
  useful_filter_keys = [];
  selected_filters = {};

  constructor(public ff_service: FFService) {
    this.ff = this.ff_service.ff;
    // we get and manipulate this.data -> graph component uses this.data
  }

  set_operating_data(data) {
    this.operating_data = [];
    if (!data) {
      console.log('no data')
    }
    for (const datum of this.data) {
      // TODO: Assuming array of datasets, allow other inputs
      // Creating new dataset so that we don't lose data passed in
      this.operating_data.push(this.ff.dataset(datum.data));
    }
  }

  ngOnInit() {
    this.build();
  }

  build() {
    if (!this.data) {
      console.log('no data');
      return;
    }
    for (const dataset of this.data) {
      dataset.on('update', this.main.bind(this));
    }
    // this.main();
  }

  // Call on changes to this.data
  // Re-compute the statistics
  // Use the statistics to create a UI for search and filter
  main() {
    for (const dataset of this.data) {
      if (!dataset.data.length) return;
    }
    this.raw_data = this.data.reduce((accumulator, current) => {
      accumulator[current.uri] = Object.assign({}, current.data);
      return accumulator;
    }, {});
    console.log('filter main')
    // Step 1: figure out what data we we're given
    // Step 2: Assign operating_data based on what you believe you can use
    this.set_operating_data(this.data);
    // TODO: Add more checks to ensure we have an array of datasets to operate on by this point
    this.data_statistics = {};
    this.data_statistics.all = this.fix_statistics(
      this.ff.visualization.new(this.operating_data.reduce((accumulator, current) => {
        accumulator = [...accumulator, ...current.data];
        return accumulator;
      }, [])),
    );
    this.useful_filter_keys = this.data_statistics.all.visualization.features.common_keys.filter(common_key => {
      return !this.ignored_keys.includes(common_key);
    });
    for (const dataset of this.operating_data) {
      // Assume we have an array of datasets
      if (!dataset.data.length) continue;
      this.data_statistics[dataset.uri] = this.fix_statistics(this.ff.visualization.new(dataset.data));
    }

    // console.log(this.data_statistics)
    // Step 3: Run this.ff.visualization.new(this.operating_data)
    // console.log(this.data);
  }

  // TODO: This code needs to be moved into the visualization code in FF
  // REASON: The current FF version 2.8.18 failed in browser and had to be reverted to 2.8.0
  // This means I cannot easily update FF right now with this code without a potential full day review of WHY it failed.
  fix_statistics(visualization) {
    // let fixed_visualization = visualization;
    const fixed_visualization = visualization;
    if (!visualization.visualization.hasOwnProperty('features')) return;
    // tslint:disable-next-line: forin
    for (const key in visualization.visualization.features.keys) {
      for (const datum of visualization.visualization.data) {
        if (!datum.hasOwnProperty(key)) continue;
        if (!fixed_visualization.visualization.features.keys[key].hasOwnProperty('unique_values')) {
          fixed_visualization.visualization.features.keys[key].unique_values = [];
        }
        if (!fixed_visualization.visualization.features.keys[key].unique_values.includes(datum[key])) {
          fixed_visualization.visualization.features.keys[key].unique_values.push(datum[key]);
        }
      }
    }
    return fixed_visualization;
  }

  reset_from_raw_data() {
    // console.log(this.raw_data)
    for (const dataset of this.data) {
      // dataset.empty();
      dataset.add(this.raw_data[dataset.uri]);
    }
  }

  // event handler for the select element's change event
  filter_change(event: any) {
    this.reset_from_raw_data()
    // update the ui
    // console.log(event);
    // console.log('selected filters', this.selected_filters);
    for (const dataset of this.data) {
      // tslint:disable-next-line: forin
      for (const key in this.selected_filters) {
        if (!this.selected_filters[key].length) {
          // console.log('no filters')
          continue; // Don't filter if there are no filters
        }
        // dataset.data = dataset.filter(datum => {
        //   return this.selected_filters[key].includes(datum[key]);
        // });
        // console.log('dataset prefilter', dataset.data)
        dataset.data = dataset.filter(datum => {
          return this.selected_filters[key].includes(datum[key]);
        });
        // console.log('dataset filtered', dataset.data);
      }
    }
    this.new_data.emit(this.data);
    // console.log(this.data)
  }

}
